// update posts
export const UPDATE_ACCOUNT = 'account:updateAccount'

export const changeAccount = (account) => ({
  type: UPDATE_ACCOUNT,
  payload: {
   account
  }
})



// WEBPACK FOOTER //
// ./src/actions/account/index.js